<template>
    <div class="canvas-onboard-activities" v-if="stage_info && is_ready">

        <div class="headline" :style="{ backgroundColor: stage_info.config.color }">
            <div class="inner">
                <div class="container">
                    <div class="details">
                        <div class="content">
                            <div class="step-num" :style="{ backgroundColor: stage_info.config.color }">Step 1</div>
                            <div class="headline-text">Read the overview and follow the stage instructions</div>
                        </div>
                        <div class="icon">
                            <img :src="stage === 'intro' ? `/images/icons/new/icon-warmup.svg` : `/images/icons/new/icon-${stage}.svg`"
                                alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="container-fluid intro-container">
            <div class="intro-row">
                <div class="my-3 intro-item" v-for="intro in intros">
                    <div class="intro-card-holder">
                        <stage-intro-card class="intro-card" :color="stage_info.config.color">
                            <template #icon>
                                <i :class="intro.icon"></i>
                            </template>
                            <template #title>
                                {{ intro.title }}
                            </template>
                            <markdown-text :content="intro.content" />
                        </stage-intro-card>
                    </div>
                </div>
            </div>
        </div>


        <div class="container-fluid" v-if="podcasts.length">
            <div v-for="podcast in podcasts">
                <!--                <iframe style="height: 80vh; width: 100%; border: none"-->
                <!--                        frameborder="0"-->
                <!--                        :src="`/podcast/${podcast.podcast.short_name}?headless=true`"></iframe>-->
                
                <iframe class="podcast-iframe my-2" style="width:100%;" frameborder="0"
                    :src="route('podcast.show', { slug: podcast.podcast.short_name, headless: 'true', hideSidebar: 'true' })"></iframe>
            </div>
        </div>

        <div class="container-fluid mt-5">
            <div class="text-center">

                <go-to-next-section title="Go to the next step" target="#step-2" :color="stage_info.config.color" />

                <div class="illustration mt-5 pt-5">
                    <img src="/images/canvas2/illustration-01.svg" alt="">
                </div>

            </div>
        </div>

        <div id="step-2" :style="{ backgroundColor: utils.colorBrightness(stage_info.config.color, 200) }">

            <div class="container">

                <div class="step-num" :style="{ background: stage_info.config.color }">Step 2</div>
                <div class="headline-text">Complete the stage activities with your team.</div>

                <div class="myrow align-items-stretch mb-4">
                    <!-- Show All Activity Tiles -->
                    <div class="my-4 activity-margin d-flex" v-for="activity in activities">
                        <stage-activity-item :stage-info="stage_info" :activity="activity.activity" />
                    </div>
                </div>


                <div class="uploads">
                    <div class="upload" v-for="upload in uploads">
                        <div class="item">
                            <file-preview type="list" @delete="removeUpload(upload)" :show-delete="true"
                                :file="upload.file" />
                        </div>
                    </div>
                </div>

                <div class="activity-closure">

                    <!-- Canvas Upload Functionality -->

                    <color-button :color="stage_info.config.color" @click="showUpload()">
                        <template #icon>
                            <i class="cvico-arrow-up"></i>
                        </template>
                        <span class="text-uppercase text-nowrap">Upload your Work</span>
                    </color-button>

                    <!--                    TODO: ActivityFileUploaderModal-->

                    <file-uploader-modal v-if="upload.show" :stage="stage" v-model="upload.data" @close="hideUpload"
                        @change="uploaded" />

                    <div class="instructions" :style="{ color: stage_info.config.color }">
                        After you've completed each activity, upload your work.
                    </div>
                </div>

                <color-canvas-button as="link" :href="route('student.canvas2.show', { uuid, ...global_url_params })"
                    :color="stage_info.config.color" />

            </div>

            <img class="circle-2" src="/images/canvas2/circles-2.svg" alt="">

        </div>

        <div class="text-center next-step-final">
            <go-to-next-section :color="stage_info.config.color" target="#step-3" title="Go to the next step" />
        </div>

        <div id="step-3" :style="{ backgroundColor: utils.colorBrightness(stage_info.config.color, 200) }">
            <div class="container-fluid">
                <div class="canvas-final-step">
                    <div class="image">
                        <lottie-animation :animationData="require('@/Animations/Canvas2/canvas-stage-final-animation.json')"
                            :loop="true" ref="anim" />
                    </div>
                    <div class="text">
                        <div class="step-num" :style="{ background: stage_info.config.color }">Step 3</div>
                        <div class="headline-text mb-4">
                            Fill your Project Canvas with pictures, text and videos of your work.
                        </div>
                        <canvas-button :color="stage_info.config.color"
                            @click.prevent.stop="$inertia.visit(route('student.canvas2.show', { uuid, ...global_url_params }))">
                            <div class="text-uppercase">
                                Edit Canvas
                            </div>
                        </canvas-button>
                    </div>
                </div>
            </div>

            <img class="circles-3" src="/images/canvas2/circles-3.svg" alt="">

        </div>

        <!--        <pre><code>{{ {_$$path, stages} }}</code></pre>-->

    </div>
</template>

<script>
import utils from "@/mixins/utils";
import { mapActions, mapGetters } from "vuex";

import StageIntroCard from "@/Components/Canvas2/StageIntroCard";
import MarkdownText from "@/Components/Common/MarkdownText";
import StageActivityItem from "@/Components/Canvas2/StageActivityItem";
import GoToNextSection from "@/Components/StudentCanvas/GoToNextSection";
import ColorButton from "@/Components/Canvas2/ColorButton";
import ColorCanvasButton from "@/Components/Canvas2/ColorCanvasButton";
import CanvasButton from "@/Components/Canvas2/CanvasButton";
import FileUploaderModal from "@/Components/Canvas2/ActivityFileUploaderModal";
import FilePreview from "@/Components/Common/FilePreview";
import jQuery from "jquery";

export default {
    name: "CanvasOnboardActivities",
    components: {
        FilePreview,
        FileUploaderModal,
        CanvasButton,
        ColorCanvasButton,
        ColorButton,
        GoToNextSection,
        StageActivityItem,
        MarkdownText,
        StageIntroCard,
    },
    mixins: [utils],
    props: ['stage'],


    data() {
        return {

            is_ready: false,


            upload: {
                show: false,
                data: null,
            }

            // activities: [
            //     {name: 'Backpack Exercise'},
            //     {name: 'Global Goals'},
            //     {name: 'Backpack Exercise'},
            // ]
        }
    },


    computed: {

        ...mapGetters('canvas2', [
            'uuid',
            'canvas2_is_ready',
            '_$$path',
            'stages',
            'getStageMissionDetails',
            'getPodcastsOnlyByStage',
            'getPathActivitiesOnlyByStage',
            'getAllCanvasActivityUploadsByStage',
        ]),

        stage_info() {
            return this.canvas2_is_ready ? this.stages.find(s => s.slug === this.stage) : null;
        },


        intros() {
            return [
                { title: 'Introduction', icon: 'cvico-intro', content: this.getStageMissionDetails(this.stage)?.description },
                { title: 'Mission', icon: 'cvico-mission', content: this.getStageMissionDetails(this.stage)?.mission },
                { title: 'Instruction', icon: 'cvico-instruction', content: this.getStageMissionDetails(this.stage)?.description }, // TODO: Not available yet in learning path.
            ];
        },

        podcasts() {
            return this.getPodcastsOnlyByStage(this.stage);
        },

        activities() {
            return this.getPathActivitiesOnlyByStage(this.stage);
        },

        uploads() {
            return this.getAllCanvasActivityUploadsByStage(this.stage);
        }

    },

    methods: {
        ...mapActions('canvas2', ['addActivityUploadOnCanvas', 'removeActivityUploadOnCanvas']),


        showUpload() {
            this.upload.show = true;
        },

        hideUpload() {
            this.upload.show = false;
        },

        uploaded() {
            const uploaded = this.upload.data;
            this.addActivityUploadOnCanvas({
                stage: this.stage,
                activity_id: uploaded.activity_id,
                file: uploaded.file,
                options: { width: 1 },
            });
            this.hideUpload();
        },

        async removeUpload(upload) {
            console.log({ removeUpload: upload });
            await this.removeActivityUploadOnCanvas(upload.id);
        },
        fixIframeHeight() {
            $.each($(".podcast-iframe"), function (key, value) {
                $(value)[0].style.height = `${$(value).contents().find("#app")[0].clientHeight}px`
            })
        },

    },

    async mounted() {
        this.is_ready = true;
        this.fixIframeHeight()
        $(window).on('resize', this.fixIframeHeight)
    }

}
</script>

<style lang="scss" scoped>
.step-num {
    display: inline-block;
    color: white;
    font-size: 1.4rem;
    padding: 0.5rem 0.8rem;
    line-height: 1;
    font-weight: $font-weight-bold;
    background: black;
    border-radius: .3rem;
    margin-bottom: 1rem;
}

.headline-text {
    font-size: 3rem;
    font-weight: $font-weight-bold;
    line-height: 1.2;

    @media (max-width: 991px) {
        font-size: 2rem;

        @media (max-width: 650px) {
            font-size: 1.5rem;
            
            @media (max-width: 450px) {
                font-size: 1rem;
            }
        }
    }
}

.headline {
    position: relative;

    &:after {
        content: url("/images/canvas2/stage-title-curve.svg");
        position: absolute;
        left: 0;
        bottom: -10px;
        right: 0;
        height: auto;
    }

    .inner {
        background: linear-gradient(180deg, rgba(255, 255, 255, 0) 10%, rgba(255, 255, 255, .2) 25%, rgba(255, 255, 255, 0.5) 100%);
        padding: 5rem 3rem 8rem 3rem;
        position: relative;
        z-index: 2;

        @media (max-width: 650px) {
            padding: 3rem 1rem 4rem 1rem;
        }
    }

    .details {
        display: flex;
        align-items: flex-end;
        flex-direction: column;
        gap: 1rem;
    }

    .content {
        max-width: 800px;
        color: white;
    }

    .icon {
        margin-left: auto;
        margin-bottom: -5rem;

        img {
            @media (max-width: 650px) {
                width: 100px;
                height: 100px;
            }
        }
    }

}

.intro-container {
    margin-top: 3rem;
    margin-bottom: 1rem;

    .intro-row {
        display: flex;
        justify-content: space-around;

        .intro-item {
            width: 100%;
            .intro-card-holder {
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 0 1.5rem;
                @media (max-width: 991px) {
                    padding: 0 1rem;
                }

                .intro-card {
                    flex-grow: 1;
                }
            }
            @media (max-width: 650px) {
                max-width: 350px;
            }
        }
        @media (max-width: 650px) {
            flex-direction: column;
            align-items: center;
        }
    }
}


.illustration {
    position: relative;
    z-index: 3;

    img {
        width: 90%;
        max-width: 480px;
        height: auto;
        display: inline-block;
    }
}

.activity-closure {
    margin: 1rem 0;
    display: flex;
    max-width: 550px;
    align-items: center;
    gap: 1rem;

    @media (max-width: 650px) {
        flex-direction: column;
        .instructions {
            text-align: center;
        }
    }
}

.canvas-final-step {
    position: relative;
    display: flex;
    align-items: center;
    max-width: 1600px;
    margin: 3rem auto 5rem;
    padding: 10rem 0 5rem;
    z-index: 2;


    .image {
        flex: 0 0 35%;
        position: relative;

        &:before {
            content: url("/images/canvas2/circles-1.svg");
            position: absolute;
            bottom: 80%;
            right: -10%;
        }
    }

    .text {
        margin-top: 5rem;
        max-width: 800px;
    }
}

#step-2 {
    position: relative;
    padding-top: 20%;
    padding-bottom: 15%;
    margin-top: -20%;

    &:before {
        content: url("/images/canvas2/stage-section-curve.svg");
        position: absolute;
        left: 0;
        right: 0;
        top: -10px;
        height: auto;
        z-index: 1;
    }

    &:after {
        content: url("/images/canvas2/stage-section-curve.svg");
        position: absolute;
        transform: rotateZ(180deg);
        left: 0;
        right: 0;
        bottom: -10px;
        height: auto;
    }

    .myrow {
        display: grid;
        grid-template-columns: auto auto auto auto;

        .activity-margin {
            margin: 0 4px;

            @media (max-width: 768px) {
                margin: 0 auto;
            }
        }

        @media (max-width: 1200px) {
            grid-template-columns: auto auto auto;
        }

        @media (max-width: 991px) {
            grid-template-columns: auto auto;
        }

        @media (max-width: 768px) {
            grid-template-columns: auto;
        }
    }

    .circle-2 {
        position: absolute;
        right: 4%;
        bottom: 0;
        width: auto;
        height: auto;
        z-index: 2;
        user-select: none;
        @media (max-width: 450px) {
            display: none;
        }
    }
}

#step-3 {
    position: relative;
    padding: 0 0 10% 0;


    &:before {
        content: url("/images/canvas2/stage-final-curve-top.svg");
        position: absolute;
        left: 0;
        right: 0;
        top: -10px;
        height: auto;
        z-index: 1;
    }

    &:after {
        content: url("/images/canvas2/stage-final-curve-bottom.svg");
        position: absolute;
        left: 0;
        right: 0;
        bottom: -10px;
        height: auto;
    }

    .circles-3 {
        position: absolute;
        bottom: 25%;
        right: 5%;
        width: auto;
        height: auto;
        z-index: 1;
        user-select: none;
    }

}

.next-step-final {
    margin-top: -5%;
    padding-bottom: 10%;
}


.uploads {
    display: grid;
    grid-template-columns: 25% 25% 25% 25%;

    @media (max-width: 991px) {
        grid-template-columns: 33.33% 33.33% 33.33%;

        @media (max-width: 650px) {
            grid-template-columns: 50% 50%;

            @media (max-width: 400px) {
                grid-template-columns: 100%;
            }
        }
    }

    .upload {
        //    width: 25%;
        //    flex: 0 0 25%;
        //    padding: 0 1rem;
        margin-bottom: 1rem;

        .item {
            position: relative;
            display: flex;
            transition: background-color .3s;
            flex-grow: 1;
            align-items: center;
            border-radius: .4rem;
            height: 100%;

            &:hover {
                background: white;
                box-shadow: rgba(black, .1) 0 1px 3px;
            }
        }
    }
}

//.next{
//    font-size: 1.1rem;
//    font-weight: $font-weight-bold;
//}
</style>
